import React from 'react';

export default () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_21139_422533)">
        <path
          d="M14.1666 7.99992C14.1666 4.59416 11.4057 1.83325 7.99992 1.83325C4.59416 1.83325 1.83325 4.59416 1.83325 7.99992C1.83325 11.4057 4.59416 14.1666 7.99992 14.1666C11.4057 14.1666 14.1666 11.4057 14.1666 7.99992ZM7.49992 10.6666V7.99992C7.49992 7.72378 7.72378 7.49992 7.99992 7.49992C8.27606 7.49992 8.49992 7.72378 8.49992 7.99992V10.6666C8.49992 10.9427 8.27606 11.1666 7.99992 11.1666C7.72378 11.1666 7.49992 10.9427 7.49992 10.6666ZM8.00643 4.83325C8.28257 4.83325 8.50643 5.05711 8.50643 5.33325C8.50643 5.60939 8.28257 5.83325 8.00643 5.83325H7.99992C7.72378 5.83325 7.49992 5.60939 7.49992 5.33325C7.49992 5.05711 7.72378 4.83325 7.99992 4.83325H8.00643ZM15.1666 7.99992C15.1666 11.958 11.958 15.1666 7.99992 15.1666C4.04188 15.1666 0.833252 11.958 0.833252 7.99992C0.833252 4.04188 4.04188 0.833252 7.99992 0.833252C11.958 0.833252 15.1666 4.04188 15.1666 7.99992Z"
          fill="#1A2022"
        />
      </g>
      <defs>
        <clipPath id="clip0_21139_422533">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
